<div class="card widget-sm widget-with-btn-group text-center" [ngClass]="bucket.color">
	<div class="card-header">
		<h2 class="card-title">{{ bucket.count }}</h2>
		@if (bucket.displayPillCount) {
			<div class="nav-tools">
				@if (bucket.pillCount !== 0) {
					<span class="badge badge-danger rounded-pill">{{ bucket.pillCount }}</span>
				}
			</div>
		}
	</div>
	<div class="btn-group d-flex" (click)="bucket.onTitleClick()">
		<a class="btn btn-sm btn-secondary flex-fill text-uppercase small" [ngClass]="{'active':bucket.active}"
		   [attr.data-test-id]="bucket.name + 'Bucket'">{{ bucket.label | uppercase }}</a>
	</div>
	<div class="btn-group d-none d-md-flex">
		@for (subBucket of bucket.subBuckets; track subBucket) {
			<a (click)="subBucket.onClick()" [ngClass]="{'active':subBucket.active}" class="btn btn-sm btn-secondary flex-fill"
			   [attr.data-test-id]="bucket.name + subBucket.label + 'SubBucket'">
				<strong>{{ subBucket.count }}</strong>
				<span class="small text-muted text-uppercase d-lg-none d-xl-inline"> {{ subBucket.label }}</span>
				<span
					class="small text-muted text-uppercase d-none d-lg-inline d-xl-none"> {{ subBucket.labelAbbreviated ? subBucket.labelAbbreviated : subBucket.label }}</span>
			</a>
		}
	</div>
</div>
